import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import "./NoFileInfo.scss";

export class NoFileInfo extends React.Component {
    render() {
        return (<div className="noFileInfo">
            <div>
                <div className="icon"><FontAwesomeIcon icon={faExclamationTriangle} /></div>
                <div>File not selected in URL</div>
            </div>

        </div>)
    }
}

export default NoFileInfo;